module.exports = __webpack_public_path__ + "static/media/bd-5.fc1a6155.svg";